<template>
  <fields-list
    :fields="fields"
    :editing-data="editingData"
    @update-field="updateField($event.value, $event.field)"
  />
</template>

<script>
import { listsMixin } from "@/mixins/listsMixin";
import { materialFamilyMixin } from "@/mixins/management/materialFamilyMixin";
import { objectManagementMixin } from "@/mixins/objectManagementMixin";
import FieldsList from "@/newComponents/StockManagement/FieldsList.vue";

export default {
  name: "AccessoryOtherMaterialFields",

  components: {
    FieldsList,
  },

  mixins: [listsMixin, materialFamilyMixin, objectManagementMixin],

  props: {
    /**
     * The specific fields values passed by the parent component
     */
    familySpecificFields: {
      type: Array | Object,
      required: true
    },

    editingData: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      /**
       * Family options for the user to choose from
       */
      familyOptions: null,
    };
  },

  /**
   * Executed when the component is mounted.
   * If the familySpecificFields has any value, these will be inserted into the familySelected attribute
   */
   mounted() {
    this.loadFamilyOptions();
  },

  watch: {
    editingData() {
      this.requiredFieldsFilled();
    },
  },

  computed: {
    fields() {
      return [
        {
          label: this.$i18n.t("MaterialFamily"),
          value: !this.editingData
            ? this.parseSelectValue(this.familySpecificFields.stock_material_other, this.familyOptions)
            : this.familySpecificFields.stock_material_other,
          varName: 'stock_material_other',
          inputType: 'multiselect',
          disabled: false,
          required: true,
          options: this.familyOptions,
          clearable: true,
          size: '100%'
        },
      ]
    }
  },

  methods: {
    /**
     * Validations for the various required fields
     *
     * @return {boolean} indicating if the fields are valid
     */
    requiredFieldsValidation() {
      return !!this.familySpecificFields.stock_material_other && this.familySpecificFields.stock_material_other.length > 0;
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/newComponents/StockManagement/SpecificMaterialSections/MaterialFieldsAccessoryOther.vue